
import Popup from 'vux/src/components/popup/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
model: {
prop: 'value',
event: 'setValue'
},
props: {
title: {
type: [String]
},
disabled: {
type: [Boolean],
default: false
},
placeholder: {
type: [String]
},
value: {
type: [String, Number],
default: ''
},
options: {
type: [Array]
}
},
directives: {
TransferDom
},
components: {
Popup,
XInput
},
created () {
},
mounted () {
this.$refs.content.style.height = window.innerHeight + 'px'
},
data () {
return {
show: false
}
},
methods: {
isShow () {
if (this.disabled) {
return
}
this.show = true
},
emitValue (item) {
this.$emit('setValue', item)
this.show = false
}
}
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/MySelector.vue